<template>
  <v-app>
    <v-content>
      <hero/>
      <introduction/>
      <course-log/>
      <program-chart/>
      <program-menu/>
      <program-info/>
      <import-dialog/>
    </v-content>
    <app-footer/>
  </v-app>
</template>

<script>
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import CourseLog from './components/CourseLog';
import ProgramChart from './components/ProgramChart';
import ProgramMenu from './components/ProgramMenu';
import ProgramInfo from './components/ProgramInfo';
import ImportDialog from './components/ImportDialog';
import AppFooter from './components/AppFooter';

export default {
  name: 'app',
  components: {
    'hero': Hero,
    'introduction': Introduction,
    'course-log': CourseLog,
    'program-chart': ProgramChart,
    'program-menu': ProgramMenu,
    'program-info': ProgramInfo,
    'import-dialog': ImportDialog,
    'app-footer': AppFooter,
  },
}
</script>